import React from 'react'
import Echo from './index'

export const EchoContext = React.createContext(Echo)

// eslint-disable-next-line react/prop-types
const EchoProvider = ({ children }) => <EchoContext.Provider value={Echo}>{children}</EchoContext.Provider>

export default EchoProvider
